import getGlassAreaLength from 'components/configurator/services/getGlassAreaLength';
import IGlassArea from 'components/interfaces/IGlassArea';
import IGlassAreaMetaData from 'components/interfaces/IGlassAreaMetaData';
import IGlassWall from 'components/interfaces/IWall';
import validGlassProperties from 'services/constants/validGlassProperties';

import {
  MAX_WEIGHT,
  QUANTITY,
} from 'services/constants/glassWidthCalculationTypes';

import getGlassWidths from './getGlassWidths';
import IValidationError from './IValidationError';

const lengthError = {
  message: `A glass is less than ${validGlassProperties.length.min}mm long`,
  property: 'length',
};

const validateGlassArea = (
  glassArea: IGlassArea,
  glassAreaMetaData: IGlassAreaMetaData,
  glassAreaIndex: number,
  wall: IGlassWall
): IValidationError[] => {
  const validationErrors = [];

  if (glassAreaMetaData.calculationType === QUANTITY) {
    const quantity = glassAreaMetaData.quantity ?? 0;

    if (quantity < validGlassProperties.quantity.min) {
      validationErrors.push({
        message: 'A glass area should have at least one glass',
        property: 'quantity',
      });
    }

    if (quantity > validGlassProperties.quantity.max) {
      validationErrors.push({
        message: `A glass area should not have over ${validGlassProperties.quantity.max} glasses`,
        property: 'quantity',
      });
    }
  }

  if (glassAreaMetaData.calculationType === MAX_WEIGHT) {
    const maxWeight = glassAreaMetaData.maxWeight ?? 0;

    if (maxWeight < validGlassProperties.maxWeight.min) {
      validationErrors.push({
        message: `Glass max weight should not be less than ${validGlassProperties.maxWeight.min}kg`,
        property: 'maxWeight',
      });
    }

    if (maxWeight > validGlassProperties.maxWeight.max) {
      validationErrors.push({
        message: `Glass max weight should not be more than ${validGlassProperties.maxWeight.max}kg`,
        property: 'maxWeight',
      });
    }
  }

  if (validationErrors.length > 0) {
    return validationErrors;
  }

  if (!wall.onlyDoor) {
    const glassWidths = getGlassWidths(
      getGlassAreaLength(glassAreaIndex, wall),
      wall,
      glassArea,
      glassAreaMetaData
    );

    for (let i = 0; i < glassWidths.length; ++i) {
      if (glassWidths[i] < validGlassProperties.length.min) {
        validationErrors.push(lengthError);
      }
    }
  }

  return validationErrors;
};

export default validateGlassArea;
